import { createReducer } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import * as actions from 'store/serviceNow/actions';
import { Incident } from './types';

export interface ServiceNowState {
  isSendingIncident: boolean;
  incidentData: Incident | {};
  incidentError: Nullable<Error>;
}

export const serviceNowInitialState = (): ServiceNowState => ({
  isSendingIncident: false,
  incidentData: {},
  incidentError: null
});

const serviceNowReducer = createReducer(serviceNowInitialState(), {
  [actions.SHARE_SERVICE_NOW]: state => {
    state.isSendingIncident = true;
    state.incidentError = null;
  },
  [actions.SHARE_SERVICE_NOW_SUCCESS]: (state, action) => {
    state.isSendingIncident = false;
    state.incidentData = action.payload.data;
  },
  [actions.SHARE_SERVICE_NOW_FAIL]: (state, action) => {
    state.isSendingIncident = false;
    state.incidentError = action.error;
  }
});

export default serviceNowReducer;
